import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {loadUsersList} from '../actions/creators';
import {Map} from 'immutable';
import {Page} from '../../layout/components';
import toastr from 'toastr';
import {UserList} from '../components';
import {ConfirmDisableUserModal, ConfirmEnableUserModal, EditUserModal, SetUserPasswordModal} from './';
import React, {Component, PropTypes} from 'react';

class UsersPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    this.props.loadUsersList()
      .catch(error => {
        toastr.error('An error occurred while attempting to load the list of user.', 'Error');
        throw error;
      });
  }

  render() {
    return (
      <Page pageClassName="users-page">
        <h1>Users</h1>
        <UserList users={this.props.users} />
        <EditUserModal />
        <ConfirmDisableUserModal />
        <ConfirmEnableUserModal />
        <SetUserPasswordModal />
      </Page>
    );
  }
}

UsersPage.propTypes = {
  loadUsersList: PropTypes.func.isRequired,
  users: PropTypes.instanceOf(Map).isRequired,
};

function mapStateToProps(state) {
  const {list} = state.features.users;

  return {
    users: list
  };
}

export default connect(
  mapStateToProps,
  {
    loadUsersList
  }
)(UsersPage);



// WEBPACK FOOTER //
// ./app/features/users/containers/UsersPage.js